<template>
  <v-card outlined class="ticket-widget">
    <v-card-title class="subtitle-1 font-weight-medium">
      <v-icon left color="primary">mdi-ticket-outline</v-icon>Mes tickets
      <v-spacer />
      <v-btn small color="primary" elevation="0" @click="showNew = true">
        <v-icon left small>mdi-plus</v-icon>Ouvrir un ticket
      </v-btn>
    </v-card-title>

    <v-progress-linear v-if="loading" indeterminate />
    <v-list v-else-if="tickets.length" dense class="py-0">
      <v-list-item v-for="t in tickets" :key="t.id" :to="{ name: 'ticket_detail', params: { id: t.id } }">
        <v-list-item-content>
          <v-list-item-title>{{ t.subject }}</v-list-item-title>
          <v-list-item-subtitle>{{ t.reference }} · {{ formatDate(t.updated_at) }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-chip x-small :color="statusColor(t.status)" dark>{{ statusLabel(t.status) }}</v-chip>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-card-text v-else class="grey--text">
      {{ failed ? 'Impossible de charger vos tickets.' : "Vous n'avez aucun ticket en cours." }}
    </v-card-text>

    <v-card-actions>
      <v-btn text small color="primary" :to="{ name: 'tickets' }">
        Voir tous mes tickets<v-icon right small>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-actions>
    <SupportNewDialog v-model="showNew" />
  </v-card>
</template>

<script>
import SupportNewDialog from '@/components/support/SupportNewDialog.vue'
import { fetchTickets } from '@/services/supportApi'
import { statusColor, statusLabel, formatDate } from '@/utils/support'

export default {
  name: 'TicketWidget',
  components: { SupportNewDialog },
  props: { limit: { type: Number, default: 4 } },
  data: () => ({ tickets: [], loading: false, failed: false, showNew: false }),
  created() {
    this.load()
  },
  methods: {
    statusColor,
    statusLabel,
    formatDate,
    /** Latest tickets authored by the current user (API orders by most recently updated). */
    async load() {
      this.loading = true
      this.failed = false
      try {
        const data = await fetchTickets({ mine: 1, page: 1 })
        this.tickets = data.results.slice(0, this.limit)
      } catch (e) {
        this.tickets = []
        this.failed = true
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
